// Soft UI Dashboard PRO React base styles
import boxShadows from "assets/theme/base/boxShadows";
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, white, transparent, light, dark, gradients } = colors;
const { borderRadius } = borders;

const autocomplete = {
  styleOverrides: {
    popper: ({ theme }) => ({
      boxShadow: lg,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: theme.palette.mode === "dark" ? white.main : text.main,
      textAlign: "left",
      backgroundColor: `${theme.palette.mode === "dark" ? "var(--input-bg-color)" : white.main} !important`,
      borderRadius: borderRadius.md,
    }),

    paper: ({ theme }) => ({
      boxShadow: "none",
      backgroundColor: theme.palette.mode === "dark" ? "var(--input-bg-color)" : transparent.main,
      color: theme.palette.mode === "dark" ? white.main : text.main,
    }),

    option: ({ theme }) => {
      const isDarkMode = theme.palette.mode === "dark";
      const hoverBackground = isDarkMode ? "rgba(116, 67, 255, 0.18)" : light.main;
      const optionTextColor = isDarkMode ? white.main : text.main;

      return {
        padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
        borderRadius: borderRadius.md,
        fontSize: size.sm,
        color: optionTextColor,
        transition: "background-color 300ms ease, color 300ms ease",

        "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
          backgroundColor: hoverBackground,
          color: optionTextColor,
        },

        '&[aria-selected="true"]': {
          backgroundColor: `${hoverBackground} !important`,
          color: `${optionTextColor} !important`,
        },
      };
    },

    noOptions: ({ theme }) => ({
      fontSize: size.sm,
      color: theme.palette.mode === "dark" ? white.main : text.main,
    }),

    groupLabel: ({ theme }) => ({
      color: theme.palette.mode === "dark" ? white.main : dark.main,
    }),

    loading: ({ theme }) => ({
      fontSize: size.sm,
      color: theme.palette.mode === "dark" ? white.main : text.main,
    }),

    tag: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      padding: pxToRem(4),
      backgroundColor: gradients.dark.state,
      color: white.main,

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
      },

      "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus": {
        color: white.main,
        marginRight: 0,
      },
    },
  },
};

export default autocomplete;
